import {
  FormType,
  ListOption,
} from '@/components/help/common/FormContainer/types';

export const EMAIL_LIST: ListOption[] = [
  {label: 'naver.com', value: 'naver.com'},
  {label: 'nate.com', value: 'nate.com'},
  {label: 'dreamwiz.com', value: 'dreamwiz.com'},
  {label: 'yahoo.co.kr', value: 'yahoo.co.kr'},
  {label: 'hotmail.com', value: 'hotmail.com'},
  {label: 'gmail.com', value: 'gmail.com'},
  {label: 'hanmail.net', value: 'hanmail.net'},
];

export const FORM_FIELDS = {
  OS_INFO: 'osInfo',
  MAIN_CATEGORY: 'mainCategory',
  SUB_CATEGORY: 'subCategory',
  EMAIL: 'customerEmail',
  TITLE: 'title',
  CONTENT: 'content',
  FILES: 'attachedFiles',
  AGREEMENT: 'agreement',
  REPORTER_NAME: 'reporterName',
  BIRTH: 'birth',
  PHONE_NUMBER: 'phoneNumber',
} as const;

export type FormFieldValues = typeof FORM_FIELDS[keyof typeof FORM_FIELDS];

export const FORM_TYPE_INQUIRY = 'inquiry'; // 문의하기
export const FORM_TYPE_REPORT = 'report'; // 신고하기
export const FORM_TYPE_ILLEGAL = 'illegal'; // 불법촬영물등 유통신고
export const FORM_TYPE_OBJECTION = 'objection'; // 이의신청

export const FORM_LABEL: Record<FormType, '문의' | '신고'> = {
  [FORM_TYPE_INQUIRY]: '문의',
  [FORM_TYPE_REPORT]: '신고',
  [FORM_TYPE_ILLEGAL]: '신고',
  [FORM_TYPE_OBJECTION]: '문의',
};

// --- 첨부파일 유효성 검사를 위한 상수 정의 ---
export const MAX_FILES = 3;
export const MAX_SIZE_MB = 10;
export const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
export const BASE_ALLOWED_EXTENSIONS = [
  '.gif',
  '.jpg',
  '.png',
  '.txt',
  '.zip',
  '.bmp',
  '.jpeg',
];

// FORM_TYPE_ILLEGAL일 때 추가되는 확장자
export const ADDITIONAL_EXTENSIONS_FOR_ILLEGAL = [
  '.doc',
  '.docx',
  '.xls',
  '.pdf',
];